import {SchemasOrderOrdersheet} from '@shared/schemas/order'

import getApi, {createApiAsyncThunk, createWrapper} from '@web/helpers/api'
import {CommonState} from '@web/slices/common/slice'

import {AffiliatePointResponse} from './interfaces'

type RootState = {
    common: CommonState
}

type ThunkApi = {
    state: RootState
    rejectValue: AffiliatePointResponse
}

const api = getApi('/orderApi')

/** 제휴 포인트 조회 */
export const getAffiliatePoint = createApiAsyncThunk<AffiliatePointResponse, void, ThunkApi>(
    'affiliate/getAffiliatePoint',
    async (_, {rejectWithValue}) => {
        const affiliatePoint = await createWrapper<SchemasOrderOrdersheet['/affiliatePoint/v2']['response']>(
            api.get('/orderSheet/affiliatePoint/v2'),
        )
        // apiSuccess 가 true 인 경우 외에는 모두 reject 로 처리합니다.
        if (affiliatePoint.apiSuccess) {
            return affiliatePoint
        }
        return rejectWithValue(affiliatePoint)
    },
)
